import React, { useState, useEffect } from "react";
import CommonSection from "../shared/CommonSection";
import "../styles/tour.css";
import tourData from "./../assets/data/tours";
import TourCard from "./../shared/TourCard";
// import SearchBar from "./../shared/SearchBar";
import Newsletter from "./../shared/Newsletter";
import { Col, Container, Row } from "reactstrap";

const Tours = () => {
  const itemsPerPage = 8; // Number of items to display per page
  const [page, setPage] = useState(0);
  const [filteredCategory, setFilteredCategory] = useState(null);
  const [activeButton, setActiveButton] = useState("South India Tours");

  useEffect(() => {
    // Create a script element for the ElfSight widget
    const script = document.createElement("script");
    script.src = "https://static.elfsight.com/platform/platform.js";
    script.setAttribute("data-use-service-core", "");
    script.defer = true;

    // Append the script element to the body
    document.body.appendChild(script);

    // Clean up by removing the script when the component unmounts
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  // Use localStorage to store and retrieve the current page
  useEffect(() => {
    const storedPage = localStorage.getItem("currentPage");
    const currentPage = storedPage ? parseInt(storedPage, 10) : 0;
    setPage(currentPage);
  }, []);

  useEffect(() => {
    localStorage.setItem("currentPage", page.toString()); // Store the current page
  }, [page]);

  const getVisibleTours = () => {
    let filteredTours = tourData;

    if (filteredCategory) {
      // Filter tours based on the selected category
      filteredTours = tourData.filter((tour) =>
        tour.categories.includes(filteredCategory)
      );
    }

    const startIndex = page * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    return filteredTours.slice(startIndex, endIndex);
  };

  const handleCategoryFilter = (category) => {
    setFilteredCategory(category);
    setPage(0); // Reset the page when changing the category filter
  };

  return (
    <>
      <CommonSection title={"All Tours"} />
      {/* <section>
        <Container>
          <Row>
            <SearchBar />
          </Row>
        </Container>
      </section> */}
      <section>
        <Container>
          <Row>
            {/* Buttons for filtering categories */}
            <div className="button__group">
              <button
                className={activeButton === "South India Tours" ? "active" : ""}
                onClick={() => handleCategoryFilter("South India Tours")}
              >
                South India Tours
              </button>
              <button
                className={
                  activeButton === "Golden Triangle Tours" ? "active" : ""
                }
                onClick={() => handleCategoryFilter("Golden Triangle Tours")}
              >
                Golden Triangle Tours
              </button>
              <button
                className={
                  activeButton === "Short Tour Packages" ? "active" : ""
                }
                onClick={() => handleCategoryFilter("Short Tour Packages")}
              >
                Short Tour Packages
              </button>
              <button
                className={
                  activeButton === "Rajasthan Tour Packages" ? "active" : ""
                }
                onClick={() => handleCategoryFilter("Rajasthan Tour Packages")}
              >
                Rajasthan Tour Packages
              </button>
              <button
                className={
                  activeButton === "Char Dham Tour Packages" ? "active" : ""
                }
                onClick={() => handleCategoryFilter("Char Dham Tour Packages")}
              >
                Char Dham Tour Packages
              </button>
              <button
                className={
                  activeButton === "Same Day Tour Packages" ? "active" : ""
                }
                onClick={() => handleCategoryFilter("Same Day Tour Packages")}
              >
                Same Day Tour Packages
              </button>
            </div>
          </Row>
        </Container>
      </section>
      <section className="pt-0">
        <Container>
          <Row>
            {getVisibleTours().map((tour) => (
              <Col lg="3" className="mb-4" key={tour.id}>
                <TourCard tour={tour} />
              </Col>
            ))}

            <Col lg="12">
              <div className="pagination d-flex align-items-center justify-content-center mt-4 gap-3">
                {[
                  ...Array(
                    Math.ceil(getVisibleTours().length / itemsPerPage)
                  ).keys(),
                ].map((number) => (
                  <span
                    key={number}
                    onClick={() => setPage(number)}
                    className={page === number ? "active__page" : ""}
                  >
                    {number + 1}
                  </span>
                ))}
              </div>
            </Col>
            <Col lg="12">
              {/* Add the ElfSight testimonial widget div */}
              <div className="elfsight-app-67d8eea9-b408-49ad-8765-9edf92c75e9a"></div>
            </Col>
          </Row>
        </Container>
      </section>
      <Newsletter />
    </>
  );
};

export default Tours;
